export class ComponentVersion {
  readonly name: string;
  readonly version: string | null;

  constructor(name: string, version: string | null) {
    this.name = name;
    this.version = version;
  }
}
